var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-popover', { attrs: { "placement": "right", "width": "330", "popper-class": "create-tag-popover" }, model: { value: _vm.visible, callback: function callback($$v) {
        _vm.visible = $$v;
      }, expression: "visible" } }, [_c('p', { staticClass: "title" }, [_vm._v("新增标签")]), _vm._v(" "), _c('create-tag', { ref: "create-tag", on: { "success": _vm.handleCreateSuccess, "cancel": _vm.handleCreateCancel } }), _vm._v(" "), _c('el-button', { directives: [{ name: "waves", rawName: "v-waves" }], attrs: { "slot": "reference", "icon": "el-icon-fa-plus", "type": "primary" }, slot: "reference" }, [_vm._v("新增标签")])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };